import { MessageBoxCheckDialog } from '../message-box-check/message-box-check.component';
import { Component, OnInit,Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FileList } from '../../models/file';
import { FilesService } from '../../services/files.service';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-file',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.css']
})
export class FilesComponent implements OnInit {
  publicating: boolean = false;
  @Input() FileID;
  @Input() nameComponent;
  @Input() Files;
  createFile: boolean = true;
  file: FileList;
  files:any;
  errorMessage: string;
  listFiles:any = [];
  textQuestion: string = "";
  typeQuestion: string;
  descriptionQuestion: string;
  name_file: string;

  constructor(public dialogRef: MdDialogRef<FilesComponent>, private dialog: MdDialog, private filesService: FilesService) { }

  ngOnInit() {
    if (this.nameComponent === "Crear"){
      this.createFile = true;
    } else {
      this.createFile = false;
    }

    this.file = new FileList();
    if (this.FileID != '') {
      this.files = this.Files;
      if(this.files.length > 0){
        //Load data FileList for ID
        this.files = this.Files;
        this.getFile(this.FileID);
      } else {
        this.files = [new FileList()];
      }
    }
  }

  getFile(id){
    for(let i = 0; i < this.files.length; i++){
      if(id === this.files[i].id){
        this.file = this.files[i];
        this.name_file = this.file.name;
        this.listFiles = this.file.docs;
      }
    }
  }
  onFilesCheck(){
    if (this.createFile) {
      this.onPostFile();
    } else {
      this.onPutFile();
    }
  }

  onFiles(){
    let dialogRef = this.dialog.open(MessageBoxCheckDialog);
    dialogRef.componentInstance.checkingData = true;
    dialogRef.componentInstance.message = "Los Documentos no se pueden editar, revisa antes de continuar.";
    dialogRef.afterClosed().subscribe(result => {
      if (result == true){
        this.onFilesCheck();
      }
      //this.onPostPublicationCheck();
    });

  }

  onPutFile() {
    this.publicating = true;
    let id = this.file.id;
    this.file = new FileList();
    this.file.id = id;
    this.file.name = this.name_file;

    this.filesService.putList(this.file)
      .subscribe(
        data => {
          this.files = data;
          this.publicating = false;
          this.dialogRef.close(data);
        },
        error => {
          console.log(error);
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: error.message, alert:true, showIcon:true}});
        }
      );
  }

  onPostFile() {
    this.addQuestion();

    this.file.name = this.name_file;
    this.file.status = 1;
    this.file.docs = this.listFiles;
    this.publicating = true;
    this.filesService.postList(this.file)
      .subscribe(
        data => {
          this.files = data
          this.publicating = false;
          this.dialogRef.close(data);
        },
        error => {
          console.log(error);
          this.errorMessage = <any>error
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: error.message, alert:true, showIcon:true}});
        }
      );
  }

  getTypeName(id) {
    if (id == "1") {
      return "Selección Simple (S/N)";
    } else if (id == "2") {
      return "Texto (Máx 140 caractéres)";
    } else if (id == "3") {
      return "Selección Simple (A,B,C,D)";
    } else if (id == "4") {
      return "Selección Multiple (A,B,C,D)";
    } else {
      return "Desconocido";
    }
  }

  addQuestion() {
    if (!this.textQuestion || !this.typeQuestion) {
      return;
    }

    if (!this.descriptionQuestion) {
      this.descriptionQuestion = '';
    }

    this.listFiles.push({
      name: this.textQuestion,
      type: this.typeQuestion,
      description: this.descriptionQuestion,
    });

    this.textQuestion = "";
    this.typeQuestion = "0";
    this.descriptionQuestion = '';
  }

  removeQuestion(elm) {
    let index = -1;

    for (let _i = 0; _i < this.listFiles.length; _i++) {
      if (this.listFiles[_i].name == elm) {
        index = _i;
        break;
      }
    }

    if (index > -1) {
      this.listFiles.splice(index, 1);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/files/files.component.ts